const Strings = Object.freeze({

  SITE_NAME: "Commit.blue",

  STILL_WORKING: "Work in progress...",
  HOME: "Home",
  NOW_PLAYING: "Now playing: ",
  NOTHING: "Nothing... 😴. (Hit play to drop the beats)",
  RF_NT: "Robert Farmer - Nottamun Town",

  NAME: "Fabio Alves Martins Pereira",
  NAME_SHORT: "Fabio A.M.P.",
  DESCRIPTION2: "You can catch me doing stuff and probably ",
  DESCRIPTION3: " on one, or more, of the social medias below.",

  SUP_YALL: "What's up y'all 🖖. As you can see, my name is Fábio, and this is my corner on the web:",
  I_AM_A: "I'm a ",
  FRONT_ENGINEER: "Front-end Web Engineer",
  WHO_ALSO_KNOWS: " who also knows a thing or two about ",
  BACKEND: "back-end",
  AND: " and ",
  ANDROID_DEV: "Android Development",
});

export default Strings;
